import {styled} from "styled-components";
import {Card} from "antd";

export const StyledCard = styled(Card)`

  .ant-card-body{
    padding: 10px 10px;
  }
`;